import angular from 'angular';
import ngSanitize from 'angular-sanitize';

import { LeadIdService } from './leadidService.js';

var module = angular.module('janglCaptureForms.jornaya', [ngSanitize]);
module.service('journayaLeadIdService', LeadIdService)
export default module.name;


// WEBPACK FOOTER //
// ./app/jornaya/index.js